module.exports = __webpack_public_path__ + "img/nike-featured.613920ed.jpg";